module.exports = __webpack_public_path__ + "img/signup-new-square-2.5ec0442d.png";